import { render, staticRenderFns } from "./ClientData.vue?vue&type=template&id=14f1aa96&"
import script from "./ClientData.vue?vue&type=script&lang=ts&"
export * from "./ClientData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports